// extracted by mini-css-extract-plugin
export var standaloneTable = "_r-0";
export var standaloneTableWithBodyFill = "_r-1";
export var withExtraHeader = "_r-2";